import * as Common from '@/agiles/common';

export enum UserTypes{
  DefaultUser = 0,
  PartnerUser = 1,
}
export enum LicenseTypes{
  DefaultLicense = 0,
  ApproveLicense = 1,
}
export class User extends Common.ObjectBase{
    constructor(){
        super('User');
        this.binders.groups = new Common.ModelBinder(Common.GroupMember);
    }    
        public id: string;
        public name: string;
        public groups: Common.GroupMember[] = new Array();
        public notifications: string[] =new Array();
        public apiKey: string;
        public proxyId: string;
        public countUserId:string;
        public isSuspended:boolean = false;
        public licenseType:LicenseTypes = LicenseTypes.DefaultLicense;
}

export class UserQuery extends Common.LoadQuery {
  constructor() {
    super('UserQuery', User);
    this.sort = 'id';
  }

  public id :string ='';
  public name: string ='';
  
}

export class UserLoadQuery extends Common.Query {
    constructor(){
        super('UserLoadQuery',new Common.ModelBinder(User,false));
    }
}

export class ProxyUserQuery extends Common.Query {
  constructor() {
    super('ProxyUserQuery', new Common.ModelBinder(User,true));
  }
}
export class UserImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, isGroup:boolean){
    super(sheetName,"");
    this.className = "UserImportQuery";
    this.isGroup = isGroup;
  }
  public isGroup:boolean;
}
export class UserExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, mfaEnabled:boolean){
    super(sheetName,loadQuery);
    this.className = "UserExportQuery";
    this.mfaEnabled = mfaEnabled;
  }
  public mfaEnabled:boolean;
}
export class GroupExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super(sheetName,loadQuery);
    this.className = "GroupExportQuery";
  }
}